import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import ProjectTypeForm from "../../components/ProjectTypeForm";
import {
    getProjectTypeList,
    addProjectType,
    updateProjectType,
    deleteProjectType
} from "../../core/actions/projectTypeAction";
import { exportFileAction } from "../../core/actions/commonAction";
import ProjectTable from "../../components/ProjectTable";
import CONSTANT from "../../core/constant/constant";

class ProjectType extends Component {
    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "first-col"
                },
                {
                    label: "labels.projectTypeCode",
                    type: "projectTypeCode",
                    isClass: "second-col",
                    sort: true
                },
                {
                    label: "labels.description",
                    type: "projectTypeName",
                    isClass: "last-col",
                    sort: true
                }
            ],
            paramList: {
                isSearch: 0,
                projectTypeCode: "",
                projectTypeName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: "projectTypeCode-ASC"
            },
            projectType: {
                projectTypeCode: "",
                projectTypeName: ""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: "",
            totalPage: 0,
            activePage: 1,
            disabled: true,
            errorCode: "",
            successCode: "",
            unSelectRow: false,
            isSearch: 0,
            btnDisable: false,
            exportDisabled: false,
            rowId: "",
            isAdded: false
        };
    }

    componentWillMount() {
        // Call API projectType-list, show list projectType
        this.props.getProjectTypeList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.projectTypeReducer.isLoading) {
            this.clearProjectType();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getProjectTypeList(this.state.paramList);
            }
        } else {
            let data = nextProps.projectTypeReducer.dataProjectType.projectTypeList;
            this.setState({
                data: data,
                totalPage: nextProps.projectTypeReducer.dataProjectType.totalPage,
                activePage: nextProps.projectTypeReducer.dataProjectType.currentPage || 1,
                btnDisable: false
            });

            // No data
            if (!data || (data && !data[0])) {
                this.setState({
                    errorCode: "018",
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.projectTypeReducer.errorCode = "";
                    }.bind(this),
                    2000
                );

            } else {
                this.setState({
                    exportDisabled: false
                });
            }

            // Data have success code
            if (nextProps.projectTypeReducer.successCode) {
                this.setState({
                    successCode: nextProps.projectTypeReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.projectTypeReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.projectTypeReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.projectTypeReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.projectTypeReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }

        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getProjectTypeList(this.state.paramList);       
    }

    // Event when click btn Search
    async searchProjectType() {
        this.clearError();
        this.setState({ btnDisable: true });
        const projectTypeCode = this.state.projectType.projectTypeCode;
        const projectTypeName = this.state.projectType.projectTypeName;

        await this.setState({
            paramList: {
                isSearch: 1,
                projectTypeCode: projectTypeCode,
                projectTypeName: projectTypeName,
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            },
            disabled: true,
            unSelectRow: false,
            isSearch: 1,
            activePage: 1
        });

        return this.props.getProjectTypeList(this.state.paramList);
    }

    // Event when click btn Add
    addProjectType = () => {
        if (!this.checkValidate()) return;
        
        this.setState({ btnDisable: true });
        const projectTypeCode = this.state.projectType.projectTypeCode;
        const projectTypeName = this.state.projectType.projectTypeName;

        this.setState({isAdded: true});
        return this.props.addProjectType({
            projectTypeCode: projectTypeCode,
            projectTypeName: projectTypeName
        });
    }

    // Event when click btn Update 
    updateProjectType = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const projectTypeCode = this.state.projectType.projectTypeCode;
        const projectTypeName = this.state.projectType.projectTypeName;
        this.setState({isAdded: false});
        return this.props.updateProjectType({
            id: id,
            projectTypeCode: projectTypeCode,
            projectTypeName: projectTypeName
        });

    }

    // Delete projectType
    deleteProjectType = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearProjectType();
       
        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({isAdded: false});
        return this.props.deleteProjectType({ id: id });
    }

    // Event when click btn Export
    projectTypeExportAction = () => {
        this.clearError();
        const exportParam = {
            projectTypeCode: this.state.paramList.projectTypeCode,
            projectTypeName: this.state.paramList.projectTypeName,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction(
            {
                urlGetkey: "ProjectType/requestSecretKey",
                urlDownfile: "ProjectType/projectTypeExport"
            },
            exportParam
        );
    }

    // Event when click clear projectType
    clearProjectType = () => {
        this.setState({
            projectType: {
                projectTypeCode: "",
                projectTypeName: ""
            },
            disabled: true,
            unSelectRow: false,
            rowId: "",
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear param list call API
    clearParamList = (isSort) => {

        this.setState({
            paramList: {
                isSearch: 0,
                projectTypeCode: "",
                projectTypeName: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: (isSort !== true) ? "projectTypeCode-ASC" : this.state.paramList.sortBy
            },
        });
    }

    // Handle on change input
    changeProjectType = evt => {
        const name = evt.target.name;
        const value = evt.target.value;
        this.setState(prevState => ({
            projectType: {
                ...prevState.projectType,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ''
                }
            }
        }));
        
    }

    // Event when click table row
    onRowClick = val => {
        this.clearError();
        let _projectType = {
            projectTypeCode: val.projectTypeCode !== null ? val.projectTypeCode : "",
            projectTypeName: val.projectTypeName !== null ? val.projectTypeName : ""
        };
        this.setState({
            disabled: false,
            projectType: _projectType,
            unSelectRow: true,
            rowId: val.id
        });
    }

    // Event when click sort table
    sortBy = async val => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val,
                rowId: val.id
            }
        }));
        this.props.getProjectTypeList(this.state.paramList);
    }

    // Event when click btn pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                projectTypeCode: this.state.paramList.projectTypeCode,
                projectTypeName: this.state.paramList.projectTypeName,
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy
            }
        });

        return this.props.getProjectTypeList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};

        (this.state.projectType.projectTypeCode.trim() === '') ? _formError['projectTypeCode'] = 'message.025' : _formError['projectTypeCode'] = '';

        (this.state.projectType.projectTypeName.trim() === '') ? _formError['projectTypeName'] = 'message.014' : _formError['projectTypeName'] = '';

        if (this.state.projectType.projectTypeCode.trim() !== '' && this.state.projectType.projectTypeName.trim() !== '') {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }

    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisable} = this.state;
        return (
            <div>
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.master")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = "/project" }, 500)}>
                        {t("navigation.project")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location.reload() }, 500)}>
                        {t("navigation.projectType")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.searchProjectType()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.addProjectType()}
                    >
                        <Icon name="add circle" />
                        {t("button.add")}
                    </Button>
                    <Button 
                    primary 
                    disabled={this.state.disabled} 
                    className="update-btn"
                    onClick={() => this.updateProjectType()}
                    >
                        <Icon name="edit" />
                        {t("button.update")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        onClick={() => this.deleteProjectType()}
                        className="delete-btn"
                    >
                        <Icon name="trash alternate outline" />
                        {t("button.delete")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.projectTypeExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button onClick={() => this.clearProjectType()}>
                        <Icon name="refresh" />
                        {t("button.clearAll")}
                    </Button>
                </div>
                <ProjectTypeForm
                    projectTypeData={this.state.projectType}
                    isError={this.state.inputSubmit.formError}
                    changeProjectType={input => this.changeProjectType(input)}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}    
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    unSelectRow={this.state.unSelectRow}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={val => this.sortBy(val)}
                />
                <div className="table-paging">
                    {this.state.data && this.state.data[0] ? (
                        <Pagination
                            size="tiny"
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name="chevron left" />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name="chevron right" />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) =>
                                this.handlePaginationChange(activePage)
                            }
                        />
                    ) : (
                            ""
                        )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getProjectTypeList: opt => dispatch(getProjectTypeList(opt)),
    addProjectType: opt => dispatch(addProjectType(opt)),
    updateProjectType: opt => dispatch(updateProjectType(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    deleteProjectType: opt => dispatch(deleteProjectType(opt))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ProjectType);
